import { PlusIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateComponentProps {
  entityName: string;
  ctaUrl?: string;
  onClickCta?: () => void;
  heading?: string;
  subHeading?: string;
}
export default function EmptyStateComponent(props: EmptyStateComponentProps) {
  // very very very naive implementation
  const plurialiseString = (str: string): string => {
    return str + 's';
  }

  return (
    <div className="p-12">
      <div className="text-center border-2 border-gray-300 border-dashed rounded-lg py-6">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900">
          {props.heading
            ? props.heading
            : `No ${plurialiseString(props.entityName)} yet.`}
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          {props.subHeading
            ? props.subHeading
            : `Get started by creating a new ${props.entityName}.`}
        </p>
        {props.ctaUrl ? (
          <div className="mt-6">
            <Link
              to={props.ctaUrl}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
            >
              <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
              New {props.entityName}
            </Link>
          </div>
        ) : (
          <></>
        )}
        {props.onClickCta ? (<div className="mt-6">
          <button
            type='button'
            onClick={props.onClickCta}
            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
          >
            <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
            New {props.entityName}
          </button>
        </div>) : <></>}
      </div>
    </div>
  );
}
